function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "#010101"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.4 50.789h29.228s-2.169-9.433-4.676-13.657c-2.03-3.42-8.184-9.105-8.184-9.105s6.154-5.685 8.184-9.105c2.507-4.223 4.676-13.657 4.676-13.657H9.4s2.17 9.434 4.677 13.657c2.03 3.42 8.183 9.105 8.183 9.105s-6.153 5.685-8.183 9.105C11.569 41.355 9.4 50.789 9.4 50.789z",
  fillRule: "evenodd",
  strokeLinecap: "square",
  strokeWidth: 1.068
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.062.597h33.904v4.669H7.062z",
  fillRule: "evenodd",
  strokeWidth: 1.068
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.014 34.448s-8.184 1.75-10.58 12.84h21.161c-2.397-11.089-10.58-12.84-10.58-12.84z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.266 17.318c2.072 4.873 5.66 7.44 6.88 7.944 0 0 4.544-3.07 6.85-7.944 0 0-3.993 1.838-6.865 1.838s-6.865-1.838-6.865-1.838z",
  strokeLinecap: "square",
  strokeWidth: 1.068
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.062 50.597h33.904v4.67H7.062z",
  fillRule: "evenodd",
  strokeWidth: 1.068
}));

var SvgHourglass = function SvgHourglass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHourglass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hourglass.bc83c967.svg";
export { ForwardRef as ReactComponent };